import { Alert, Text } from 'braid-design-system';

export const AbsurdSalaryMessage = ({ message }: { message: string }) => (
  <Alert tone="caution" id="absurdly-high-salary-banner">
    <Text>{message}</Text>
  </Alert>
);
